import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { afterReceiving as afterReceivingLeaves } from '@/services/leave/hooks'
import { afterReceiving as afterReceivingProject } from '../project/hooks';
import { JobFromUTC } from '@/services/resource/hooks'


// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

export const afterReceivingResourceTimesheetLeave = (data:any[]) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOneResourceTimesheetLeave(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOneResourceTimesheetLeave(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOneResourceTimesheetLeave(data);
  }
  return data;
}

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      booking: object.booking && object.booking.map((bookingItem:any)=>{
        return {
          ...bookingItem,
          validationDate: bookingItem.validationDate && newDateFromUTC(bookingItem.validationDate),
          project: bookingItem.project && afterReceivingProject(bookingItem.project)
        }
      })
    }
  }
  return object;
}

export const afterReceivingOneResourceTimesheetLeave = (object:any) => {
  if(typeof object == 'object'){ 
    return {
      ...object,
      jobs: Array.isArray(object.jobs) ? object.jobs.map(JobFromUTC) : object.jobs,
      leaves:afterReceivingLeaves(object.leaves),
      timesheet: object.timesheet && afterReceivingOne(object.timesheet),
    }
  }
  return object;
}

// OBJECT FIELDS






// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object
    }
  }
  return object;
}

// OBJECT FIELDS


